import React, { useEffect, useState } from 'react'
import socketIOClient from 'socket.io-client'

import API from '../../api'
import BootstrapTable from 'react-bootstrap-table-next'
import Loader from '../common/Loader'
import RaceHeader from './RaceHeader'
import MoreInfo from './MoreInfo'
import getTime from './formatTime'

const timeFormatter = (cell, row, rowIndex, formatExtraData) => {
  if (cell > 0) {
    return (
      <span>
        <div className='time'>{getTime(row.times[row.times.length - 1])}</div>
        <div className='font14'>{formatExtraData.splits[row.times.length - 1].distance} km</div>
        <div className='font14'>@ {formatExtraData.splits[row.times.length - 1].checkpoint.name}</div>
      </span>
    )
  } else {
    return '-'
  }
}

const gapFormatter = (cell, row) => {
  if (cell === 0) return '-'
  if (cell === parseInt(cell, 10)) {
    return '+ ' + getTime(cell)
  }
  return cell
}

const nameFormatter = (cell, row) => {
  if (row.team) {
    return (
      <span>
        <div className='name'>{cell}</div>
        <div className='team'>Club: {row.team}</div>
      </span>
    )
  }
  return (
    <span>
      <div className='name'>{cell}</div>
    </span>
  )
}

const compareCompetitors = (a, b) => {
  if (a.status !== 'OK' || b.status !== 'OK') {
    return (a.status > b.status) ? -1 : 1
  } else {
    if (a.times.length !== b.times.length) {
      return b.times.length - a.times.length
    } else if (a.times.length === 0) {
      return a.number - b.number
    } else {
      return a.times[a.times.length - 1] - b.times[b.times.length - 1]
    }
  }
}

const sortCompetitors = (competitors) => {
  competitors = competitors.sort(compareCompetitors)
  let index = 1
  competitors.map(c => {
    if (c.status === 'OK') {
      if (c.times.length > 0) {
        c.position = index++
      } else {
        c.position = ''
      }
    } else {
      c.position = c.status
    }
    return c
  })

  competitors.map(c => {
    c.time = (c.times.length > 0) ? c.times[c.times.length - 1] : 0
    return c
  })
  let first = competitors[0]
  if (first) {
    if (first.time > 0) {
      competitors.map(c => {
        let checks = first.times.length - c.times.length
        if (checks === 0) {
          c.gap = c.time - first.time
        } else {
          c.gap = `- ${checks} check${(checks > 1) ? 's' : ''}`
        }
        return c
      })
    } else {
      competitors.map(c => {
        c.gap = '-'
        return c
      })
    }
  }
  return competitors
}

const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

const columns = (data) => {
  return [
    {
      dataField: 'position',
      text: '#',
      headerStyle: { width: '4%' },
      align: 'center',
      headerAlign: 'center'
    }, {
      dataField: 'number',
      text: 'Bib',
      headerStyle: { width: '5%' },
      align: 'center',
      headerAlign: 'center'
    }, {
      dataField: 'name',
      text: 'Name',
      headerStyle: { width: '31%' },
      formatter: nameFormatter,
      style: {
        paddingLeft: '0.25rem'
      }
    }, {
      dataField: 'city',
      text: 'City',
      headerStyle: { width: '20%' },
      style: {
        paddingLeft: '0.25rem'
      }
    }, {
      dataField: 'sex',
      text: '',
      headerStyle: { width: '6%' },
      align: 'center'
    }, {
      dataField: 'time',
      text: 'Time',
      headerStyle: { width: '20%' },
      formatter: timeFormatter,
      align: 'center',
      headerAlign: 'center',
      formatExtraData: data
    }, {
      dataField: 'gap',
      text: 'Gap',
      headerStyle: { width: '14%' },
      formatter: gapFormatter,
      align: 'center',
      headerAlign: 'center'
    }
  ]
}

const RacePage = (props) => {
  
  const {event, race, sex} = props.match.params

  const [loading, setLoading] = useState(true)
  const [loadingTable, setLoadingTable] = useState(true)
  const [raceData, setRaceDate] = useState()
  const [competitors, setCompetitors] = useState([])

  const changeCompetitorTimes = (run) => {
    setCompetitors(competitors => {
      const data = [...competitors]
      const index = data.findIndex(c => c.id === run.id)
      if (index >= 0) {
        data[index] = Object.assign({}, {...data[index], times: run.times})
        console.log(data[index])
        return sortCompetitors(data)
      }
      console.log(data)
      return data
    })
    
  }

  useEffect(() => {
    console.log(race)
    setLoadingTable(false)
    const socket = socketIOClient(process.env.REACT_APP_DOMAIN, {
      path: process.env.REACT_APP_API_SOCKET
    })
    socket.on('connect', () => {
      console.log('connect')
      // API.fetchDataForEvent(this.props.match.params.event, this.from)
      //   .then(result => {
      //     // notify.hide()
      //     if (result.data.refresh) {
      //       window.location.reload()
      //     } else {
      //       result.data.points.forEach(d => {
      //         players.filter(p => p.device === d.device)[0].track.push(d)
      //       })
      //       players.forEach(p => p.track.sort((a, b) => a.time - b.time))
      //       this.setState({
      //         players
      //       })
      //       this.from = null
      //     }
      //   })
      //   .catch(err => console.log(err))
    })
    socket.on(race, changeCompetitorTimes)
    socket.on('disconnect', () => {
      // notify.show('Lost connection', 'error', -1)
      console.log('disconnect')
      // this.from = new Date().getTime()
    })
    return () => socket.close()
  }, [race])

  useEffect(() => {
    setLoadingTable(true)
    API.fetchRace(event, race, sex ? sex : 'all')
      .then(res => {
        let data = Object.assign({}, res.data)
        delete data.competitors
        setRaceDate(data)
        setCompetitors(sortCompetitors(res.data.competitors))
        setLoading(false)
        setLoadingTable(false)
      })
  }, [event, race, sex])

  if (loading) {
    return <Loader loading={loading} />
  }

  const  rowStyle = (row, rowIndex) => {
    let per = row.times.length / raceData.splits.length
    let {r, g, b} = hexToRgb(raceData.color)
    return {
      backgroundColor: `rgba(${r}, ${g}, ${b}, ${per})`
    }
  }

  const expandRow = {
    renderer: row => (
      <MoreInfo race={raceData} row={row} />
    )
  }

  console.log(competitors)
  return (<div className='container'>
    <RaceHeader race={raceData} />
    {!loadingTable &&
      <BootstrapTable
        wrapperClasses='table-responsive-lg'
        classes='table-hover table-results'
        keyField='id'
        data={competitors}
        columns={columns(raceData)}
        rowStyle={rowStyle}
        expandRow={expandRow}
      />
    }
  </div>)
}

// class RacePage extends Component {
//   constructor (props) {
//     super(props)
//     this.state = {
//       loading: true,
//       loadingTable: true
//     }
//     this.changeCompetitorTimes = this.changeCompetitorTimes.bind(this)
//     this.rowStyle = this.rowStyle.bind(this)
//     this.loadRaceData = this.loadRaceData.bind(this)
//     let sex = (props.match.params.sex) ? props.match.params.sex : 'all'
//     this.loadRaceData(props.match.params.event, parseInt(props.match.params.race), sex)
//   }

//   componentWillReceiveProps (props) {
//     this.state.socket.close()
//     this.setState({
//       loadingTable: true
//     })
//     this.loadRaceData(props.match.params.event, parseInt(props.match.params.race), props.match.params.sex)
//   }

//   loadRaceData (eventSlug, raceId, sex = 'all') {
//     API.fetchRace(eventSlug, raceId, sex)
//       .then(res => {
//         let data = Object.assign({}, res.data)
//         delete data.competitors
//         let competitors = sortCompetitors(res.data.competitors)

        

//         this.setState({
//           race: data,
//           competitors,
//           loading: false,
//           loadingTable: false,
//           columns,
//           socket
//         })
//       })
//   }

//   rowStyle (row, rowIndex) {
//     let per = row.times.length / this.state.race.splits.length
//     let {r, g, b} = hexToRgb(this.state.race.color)
//     return {
//       backgroundColor: `rgba(${r}, ${g}, ${b}, ${per})`
//     }
//   }

//   changeCompetitorTimes (data) {
//     let competitors = this.state.competitors
//     let comp = competitors.filter(c => c.id === data.id)[0]
//     if (comp) {
//       comp.times = data.times
//       competitors = sortCompetitors(competitors)
//       this.setState({competitors})
//     }
//   }

//   render () {
//     const expandRow = {
//       renderer: row => (
//         <MoreInfo race={this.state.race} row={row} />
//       )
//     }
//     return (
//       <div className='container'>
//         <Loader loading={this.state.loading} />
//         {!this.state.loading &&
//           <RaceHeader race={this.state.race} />
//         }
//         {!this.state.loadingTable &&
//           <BootstrapTable
//             wrapperClasses='table-responsive-lg'
//             classes='table-hover table-results'
//             keyField='id'
//             data={this.state.competitors}
//             columns={this.state.columns}
//             rowStyle={this.rowStyle}
//             expandRow={expandRow}
//           />
//         }
//       </div>
//     )
//   }
// }

export default RacePage
